import { h5_recordEvent } from '@/api/lottery'

const path = location.pathname

if (path.indexOf('cloud-mining-ad') !== -1) {
  h5_recordEvent({
    eventName: 'mining_guiding_page_show',
    count: 1
  })
  document.addEventListener("DOMContentLoaded", () => {
    document.getElementById('img-btn').addEventListener('touchstart', () => {
      h5_recordEvent({
        eventName: 'mining_guiding_page_click',
        count: 1
      })
    })
  })
}

if (path.indexOf('coin-play-ad') !== -1) {
  document.addEventListener("DOMContentLoaded", () => {
    document.getElementById('img-btn').addEventListener('touchstart', () => {
      h5_recordEvent({
        eventName: 'one_guiding_page_click',
        count: 1
      })
    })
  })
}
